import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';


@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor() { }

  getAllUsuarios(){
    return gql`
      query getAllUsuarios {
          users(sort: "createdAt:DESC") {
            id
            username
            email
            name
            inproeco
            cliente{
              nombreComercial
            }
            contratista {
              nombreComercial
            }
          }
        }
    `;
  }

  getUsuariosById(){
    return gql`
      query getUsuariosById($id: ID!) {
        user(id: $id) {
            id
            username
            email
            name
            inproeco
            rol
            mensaje
            cliente{
              id
              nombreComercial
              cif
              xtensaBasica
            }
            zonas{
              id
            }
            agrupacions{
              id
            }
            contratista{
              nombreComercial
              id
              cif
              xtensaBasica
              razonSocial
              direccion{
                tipoVia
                nombre
                numero
                provincia
                localidad
                ccaa
                codigoPostal
              }
            }
          }
        }
    `;
  }

  addUser(){
    return gql`
      mutation createUser($input: createUserInput!) {
      createUser(input: $input) {
        user {
          id
          name
          email
        }
      }
    }
    `;
  }

  updateUsuario(){
    return gql`
      mutation updateUser($input: updateUserInput!) {
        updateUser(input: $input) {
          user {
            id
            
          }
        }
      }
    `;
  }

  deleteUser(){
    return gql`
      mutation deleteUser($input: deleteUserInput!) {
        deleteUser(input: $input) {
          user {
            id
            cliente{
              cif
            }
          }
        }
      }
    `;
  }

  
}
